(function(){
  var root=document.querySelector('.wam-sl'); if(!root) return;
  var SRC=(document.currentScript&&document.currentScript.src)||'';
  var cards=[].slice.call(root.querySelectorAll('.wam-sl-card'));
  var blocs=[].slice.call(root.querySelectorAll('.wam-sl-bloc'));
  var f={pays:'',mois:'',q:'',pro:false,expo:null};
  var map=null, markers={}, EXPO=null;
  function sansAccent(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
  function cle(s){return sansAccent(s).replace(/[^a-z0-9]/g,'');}
  function visible(c){
    if(f.expo && f.expo.ids.indexOf(c.id)<0) return false;
    if(f.pays && c.dataset.pays!==f.pays) return false;
    if(f.mois && c.dataset.mois!==f.mois) return false;
    if(f.pro && c.dataset.type==='pro') return false;
    if(f.q){var t=c.dataset.t||(c.dataset.t=sansAccent(c.textContent)); if(t.indexOf(sansAccent(f.q))<0) return false;}
    return true;
  }
  function appliquer(){
    var n=0;
    cards.forEach(function(c){var v=visible(c);c.hidden=!v;c.style.display=v?'':'none';if(v)n++;
      var m=markers[c.id]; if(m&&map){ if(v&&!map.hasLayer(m)) m.addTo(map); if(!v&&map.hasLayer(m)) map.removeLayer(m);} });
    blocs.forEach(function(b){b.hidden=!b.querySelector('.wam-sl-card:not([hidden])');});
    document.getElementById('wam-sl-vide').hidden=n>0;
    var chip=f.pays?root.querySelector('.wam-sl-chip.is-on'):null;
    document.getElementById('wam-sl-compte').textContent=n+' salon'+(n>1?'s':'')+' affiché'+(n>1?'s':'')+(chip?' · '+chip.textContent.replace(/^[^A-Za-zÀ-ɏ]+/,'').trim():'');
  }
  function cadrer(){ if(!map) return; map.invalidateSize(); var pts=[];
    (window.WAM_SALONS||[]).forEach(function(s){var c=document.getElementById(s.id); if(c&&!c.hidden) pts.push([s.la,s.lo]);});
    if(pts.length) map.fitBounds(pts,{padding:[30,30],maxZoom:8}); }
  root.querySelectorAll('.wam-sl-chip').forEach(function(b){b.addEventListener('click',function(){
    root.querySelectorAll('.wam-sl-chip').forEach(function(x){x.classList.remove('is-on');});
    b.classList.add('is-on'); f.pays=b.dataset.pays; appliquer(); cadrer();
    /* 03/11/2026 : choisir un pays affiche directement la carte, cadrée sur ce pays (les fiches dessous sont déjà filtrées) */
    if(f.pays&&!map){var cb=document.getElementById('wam-sl-carte-btn');if(cb&&!cb.disabled)cb.click();}
  });});
  document.getElementById('wam-sl-mois').addEventListener('change',function(e){f.mois=e.target.value;appliquer();cadrer();});
  document.getElementById('wam-sl-q').addEventListener('input',function(e){f.q=e.target.value.trim();appliquer();});
  document.getElementById('wam-sl-pro').addEventListener('change',function(e){f.pro=e.target.checked;appliquer();});

  /* ---------- Recherche par exposante ---------- */
  function el(tag,cls,txt){var x=document.createElement(tag);if(cls)x.className=cls;if(txt!=null)x.textContent=txt;return x;}
  var boite=el('div','wam-sl-expo-recherche');
  var lab=el('label','wam-sl-sel wam-sl-sel--expo');
  lab.appendChild(el('span',null,'Chercher une teinturière / un exposant'));
  var inp=el('input'); inp.type='search'; inp.placeholder='Nom de la marque…'; inp.setAttribute('autocomplete','off'); inp.disabled=true;
  lab.appendChild(inp); boite.appendChild(lab);
  var sug=el('ul','wam-sl-sug'); sug.hidden=true; boite.appendChild(sug);
  var bandeau=el('div','wam-sl-expo-bandeau'); bandeau.hidden=true;
  var filtres=root.querySelector('.wam-sl-filtres');
  filtres.insertBefore(boite,filtres.querySelector('.wam-sl-ligne'));
  filtres.appendChild(bandeau);
  function annee(id){var a=EXPO.annees[id.slice(1)];return a?String(a):'';}
  /* 03/11/2026 : une liste d'exposants n'est « officielle » pour un salon que si elle est celle de sa prochaine
     édition datée : date annoncée (statut ≠ a_venir) ET année de la liste = année de la date de début.
     Sinon (date pas encore annoncée, édition passée, ou liste d'une année précédente), on n'annonce pas
     l'exposant sur ce salon : la liste reste consultable sur la fiche, marquée « édition passée ». */
  function officielle(id){var c=document.getElementById(id);if(!c)return false;
    var d=c.dataset.debut||'',y=annee(id);
    return c.dataset.statut!=='a_venir'&&!!y&&d.slice(0,4)===y;}
  function choisir(e){
    var ok=e[2].filter(officielle), passes=e[2].length-ok.length;
    inp.value=e[0]; sug.hidden=true;
    bandeau.innerHTML='';
    var t=el('p'); t.appendChild(el('b',null,'🧶 '+e[0]));
    if(ok.length){
      f.expo={nom:e[0],lien:e[1],ids:ok};
      t.appendChild(document.createTextNode(' — annoncé'+' sur '+ok.length+' salon'+(ok.length>1?'s':'')+' à venir, d\'après les listes officielles publiées par les organisateurs.'));
    } else {
      f.expo=null;
      t.appendChild(document.createTextNode(' — pas encore annoncé sur un salon à venir : les organisateurs n\'ont pas encore publié leurs listes.'));
    }
    if(passes) t.appendChild(document.createTextNode(' (Présent sur '+passes+' liste'+(passes>1?'s':'')+' d\'éditions passées.)'));
    bandeau.appendChild(t);
    var acts=el('p');
    if(e[1]){var a=el('a',null,'Sa page ↗');a.href=e[1];a.target='_blank';a.rel='nofollow noopener';acts.appendChild(a);}
    var x=el('button','wam-sl-expo-x','✕ Effacer');x.type='button';x.addEventListener('click',effacer);acts.appendChild(x);
    bandeau.appendChild(acts); bandeau.hidden=false;
    cards.forEach(function(c){var old=c.querySelector('.wam-sl-ici');if(old)old.remove();c.classList.remove('wam-sl-card--expo');
      if(ok.indexOf(c.id)>=0){c.classList.add('wam-sl-card--expo');
        var y=annee(c.id);
        c.insertBefore(el('p','wam-sl-ici','★ '+e[0]+' figure sur la liste officielle '+y),c.querySelector('h3').nextSibling);}});
    appliquer(); cadrer();
    var premier=ok.length?cards.filter(function(c){return !c.hidden;})[0]:null;
    if(premier&&!map) premier.scrollIntoView({behavior:'smooth',block:'center'});
  }
  function effacer(){f.expo=null;inp.value='';bandeau.hidden=true;
    cards.forEach(function(c){var o=c.querySelector('.wam-sl-ici');if(o)o.remove();c.classList.remove('wam-sl-card--expo');});
    appliquer(); cadrer();}
  inp.addEventListener('input',function(){
    var q=cle(inp.value); sug.innerHTML='';
    if(q.length<2){sug.hidden=true;return;}
    var r=EXPO.e.filter(function(e){return e._k.indexOf(q)>=0;}).sort(function(a,b){return (a._k.indexOf(q)===0?0:1)-(b._k.indexOf(q)===0?0:1)||b._ok-a._ok||b[2].length-a[2].length;}).slice(0,8);
    if(!r.length){sug.appendChild(el('li','wam-sl-sug-vide','Aucun exposant trouvé dans les listes publiées'));sug.hidden=false;return;}
    r.forEach(function(e){var li=el('li');var b=el('button',null,e[0]);b.type='button';
      b.appendChild(el('small',null,e._ok?' · '+e._ok+' salon'+(e._ok>1?'s':'')+' à venir':' · éditions passées uniquement'));
      b.addEventListener('click',function(){choisir(e);});li.appendChild(b);sug.appendChild(li);});
    sug.hidden=false;
  });
  document.addEventListener('click',function(ev){if(!boite.contains(ev.target))sug.hidden=true;});

  /* ---------- Listes d'exposants sur les fiches ---------- */
  function listes(){
    Object.keys(EXPO.liens||{}).forEach(function(k){var c=document.getElementById('s'+k);if(!c)return;var p=el('p','wam-sl-expos-src');var a=el('a',null,'Liste des exposants sur le site du salon ↗');a.href=EXPO.liens[k];a.target='_blank';a.rel='nofollow noopener';p.appendChild(a);var l=c.querySelector('.wam-sl-liens');c.insertBefore(p,l.nextSibling);});
    var parSalon={};
    EXPO.e=EXPO.e.map(function(e){var l=e.length===3?e[1]:'';
      if(l) l=l.charAt(0)==='@'?'https://www.instagram.com/'+l.slice(1)+'/':'https://'+l;
      return [e[0],l,e[e.length-1].map(function(n){return 's'+n;})];});
    EXPO.listes=(EXPO.listes||[]).map(function(n){return 's'+n;});
    EXPO.e.forEach(function(e){e._k=cle(e[0]);e._ok=e[2].filter(officielle).length;e[2].forEach(function(id){(parSalon[id]=parSalon[id]||[]).push(e);});});
    (EXPO.listes||[]).forEach(function(id){
      var c=document.getElementById(id); var L=parSalon[id]; if(!c||!L) return;
      var d=el('details','wam-sl-expos');
      var y=annee(id), off=officielle(id);
      d.appendChild(el('summary',null,(off?'Exposants'+(y?' '+y:''):'Exposants de l\'édition'+(y?' '+y:'')+' (passée)')+' · '+L.length));
      var ul=el('ul');
      L.forEach(function(e){var li=el('li');
        if(e[1]){var a=el('a',null,e[0]);a.href=e[1];a.target='_blank';a.rel='nofollow noopener';li.appendChild(a);}else li.textContent=e[0];
        var autres=e[2].filter(function(x){return x!==id&&officielle(x);}).length;
        if(autres>0){var b=el('button','wam-sl-autres','+'+autres+' salon'+(autres>1?'s':'')+' à venir');b.type='button';b.title='Voir ses salons à venir';b.addEventListener('click',function(){choisir(e);root.scrollIntoView({behavior:'smooth'});});li.appendChild(b);}
        ul.appendChild(li);});
      d.appendChild(ul);
      if(EXPO.sources&&EXPO.sources[id.slice(1)]){var p=el('p','wam-sl-expos-src','Liste publiée par l\'organisateur — ');var a=el('a',null,'voir la source ↗');a.href=EXPO.sources[id.slice(1)];a.target='_blank';a.rel='nofollow noopener';p.appendChild(a);d.appendChild(p);}
      var liens=c.querySelector('.wam-sl-liens'); c.insertBefore(d,liens.nextSibling);
    });
  }
  /* 03/11/2026 : wam-exposants-ajouts.json complète wam-exposants.json (même nom d'exposant = même exposant) */
  function fusion(d,a){
    (a.listes||[]).forEach(function(n){d.listes=d.listes||[];if(d.listes.indexOf(n)<0)d.listes.push(n);});
    ['annees','sources','liens'].forEach(function(k){if(a[k]){d[k]=d[k]||{};for(var x in a[k])d[k][x]=a[k][x];}});
    var idx={}; d.e.forEach(function(e){idx[e[0]]=e;});
    (a.e||[]).forEach(function(n){var ids=n[n.length-1],ex=idx[n[0]];
      if(ex){var L=ex[ex.length-1];ids.forEach(function(i){if(L.indexOf(i)<0)L.push(i);});}
      else{d.e.push(n);idx[n[0]]=n;}});
    return d;
  }
  var url=SRC?SRC.replace('wam-salons-laine.js','wam-exposants.json'):'';
  var url2=SRC?SRC.replace('wam-salons-laine.js','wam-exposants-ajouts.json'):'';
  if(url&&window.fetch){fetch(url).then(function(r){return r.json();}).then(function(d){
      return fetch(url2).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}).then(function(a){return a?fusion(d,a):d;});
    }).then(function(d){EXPO=d;listes();inp.disabled=false;}).catch(function(){boite.hidden=true;});}
  else boite.hidden=true;

  /* ---------- Carte ---------- */
  function charger(src,cb){var s=document.createElement('script');s.src=src;s.onload=cb;document.head.appendChild(s);}
  document.getElementById('wam-sl-carte-btn').addEventListener('click',function(){
    var btn=this; btn.disabled=true; btn.textContent='Chargement…';
    var l=document.createElement('link');l.rel='stylesheet';l.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(l);
    charger('https://unpkg.com/leaflet@1.9.4/dist/leaflet.js',function(){
      var zone=document.getElementById('wam-sl-carte'); zone.innerHTML='';
      map=L.map(zone,{scrollWheelZoom:false}).setView([50,5],4);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18,attribution:'© contributeurs OpenStreetMap'}).addTo(map);
      (window.WAM_SALONS||[]).forEach(function(s){
        var cls='wam-sl-pin wam-sl-pin--'+(s.w?'wam':s.s);
        var m=L.marker([s.la,s.lo],{icon:L.divIcon({className:'',html:'<div class="'+cls+'"></div>',iconSize:[22,22],iconAnchor:[11,11]}),title:s.n});
        var div=el('div','wam-sl-pop');
        div.appendChild(el('b',null,s.n));
        div.appendChild(el('br')); div.appendChild(document.createTextNode(s.v+' · '+s.p));
        div.appendChild(el('br')); div.appendChild(document.createTextNode(s.d));
        if(s.w){div.appendChild(el('br'));div.appendChild(document.createTextNode('★ Wool and Magic y sera'));}
        div.appendChild(el('br'));
        var a=el('a',null,'Voir la fiche ↓'); a.href='#'+s.id;
        a.addEventListener('click',function(ev){ev.preventDefault();var c=document.getElementById(s.id);c.scrollIntoView({behavior:'smooth',block:'center'});c.classList.add('is-flash');setTimeout(function(){c.classList.remove('is-flash');},1800);});
        div.appendChild(a); m.bindPopup(div); markers[s.id]=m;
      });
      appliquer(); cadrer();
    });
  });
  appliquer();
})();
